import { colors } from "@mui/material";
import { ThemeOptions } from "@mui/material/styles";

export const DarkTheme:ThemeOptions = {
  /*liveEditor: {
    color1: '#034694',
    color2: '#1560bd',
  },*/
  palette: {
    mode: "dark",
    primary: {
      main: "#42a5f5",
    },
    secondary: {
      main: "#0b1b31", // SideMenu and AppBar
    },
    background: {
      default: "#101c2c", // Big background
      paper: "#001a3c", // Front-Box
    },
  },
  components: {
    MuiTabs: {
      styleOverrides: {
        root: {
          '& .MuiTabs-indicator': {
            display: 'none',
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: 'grey',
          fontWeight: 'bold',
          marginBottom: '0.313rem',
          marginTop: '0.313rem',
          '&.Mui-selected': {
            color: 'white',
            backgroundColor: colors.blue[500],
            borderRadius: '60rem'
          },
        },
      }
    }
  }
};
